var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListOrdered = function SvgListOrdered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.4 4.8h11.7v1.8H8.4zm-2.7-.9v2.7h.9v.9H3.9v-.9h.9V4.8h-.9v-.9zm-1.8 9.9v-2.25h1.8v-.45H3.9v-.9h2.7v2.25H4.8v.45h1.8v.9zm1.8 4.95H3.9v-.9h1.8v-.45H3.9v-.9h2.7v3.6H3.9v-.9h1.8zm2.7-7.65h11.7v1.8H8.4zm0 6.3h11.7v1.8H8.4z"
  })));
};
export default SvgListOrdered;